import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IProfileListStrings extends LocalizedStringsMethods {
    lsActionTxt: string;
    lsViewTxt: string;
    lsHomeTxt: string;
    lsAddTxt: string;
    lsEditTxt: string;   
    lsFirstName: string;    
    lsMiddleName: string;
    lsLastName: string;    
    lsOrgTxt: string;
    lsLevelTxt: string;
    lsProfilesTxt: string;
    lsIDTxt: string;
    lsSportTxt: string;
    lsBDayTxt: string;
    lsGenderTxt: string;
    lsTotalProfilesTxt: string;
    lsEmailTxt: string;
    lsPhoneTxt: string;
    lsNotifyEmailTxt: string;
    lsNotifyPhonesTxt: string;
    lsConcussionTxt: string;
    lsPageTxt: string;
}

let strings: IProfileListStrings;
export default strings = new LocalizedStrings({
    en: {      
        lsActionTxt: 'Action',
        lsViewTxt: 'View',
        lsHomeTxt: 'Home',
        lsAddTxt: 'Add',
        lsEditTxt: 'Edit',
        lsFirstName: 'First Name',  
        lsMiddleName: 'Middle Name',
        lsLastName: 'Last Name',
        lsBDayTxt: 'Birthdate',
        lsOrgTxt: 'Organization',
        lsLevelTxt: 'Level',
        lsProfilesTxt: 'Profile',        
        lsIDTxt: 'Id',
        lsSportTxt: 'Sport',        
        lsGenderTxt: 'Gender',
        lsTotalProfilesTxt: 'Total {0} profiles',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Phone',
        lsNotifyEmailTxt: 'Notification Emails',
        lsNotifyPhonesTxt: 'Notify Phone(s)',
        lsConcussionTxt: 'Dx Concussion',
        lsPageTxt: 'page'
    },
    es: {
        lsActionTxt: 'Acción',
        lsViewTxt: 'Ver',
        lsHomeTxt: 'Casa',
        lsAddTxt: 'Añadir',
        lsEditTxt: 'Editar',
        lsFirstName: 'Nombre de pila',  
        lsMiddleName: 'Segundo nombre',
        lsLastName: 'Apellido',
        lsBDayTxt: 'Fecha de nacimiento',
        lsSelectGenderTxt: 'Seleccione género',
        lsOrgTxt: 'Organización',
        lsLevelTxt: 'Nivel',
        lsProfilesTxt: 'Profile',        
        lsIDTxt: 'Carné de identidad',
        lsSportTxt: 'Deportes',        
        lsGenderTxt: 'Género',
        lsTotalProfilesTxt: 'Total de {0} perfiles',
        lsContactInfoTxt: 'Contacto y notificación de información',
        lsEmailTxt: 'Email',
        lsPhoneTxt: 'Teléfono',
        lsNotifyEmailTxt: 'Mensajes de correo electrónico de notificación',
        lsNotifyPhonesTxt: 'Teléfonos de notificaciones',
        lsConcussionTxt: 'Conmoción cerebral Dx',
        lsPageTxt: 'página'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/profile/strings.profile.list.tsx